import { render, staticRenderFns } from "./zhibiao.vue?vue&type=template&id=2959c6a4&scoped=true"
import script from "./zhibiao.vue?vue&type=script&lang=js"
export * from "./zhibiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2959c6a4",
  null
  
)

export default component.exports